import * as yup from 'yup';
import { validarCNPJ } from '../../../../../services/utils';

export const formCdValidator = yup.object().shape({
    cnpj: yup
        .string()
        .required("Campo obrigatório")
        .test('validar-cnpj', 'Favor inserir um CNPJ válido', (value) => {
            if (value) {
                return validarCNPJ(value);
            } else {
                return false;
            }
        }),
    razaoSocial: yup
        .string()
        .required("Campo obrigatorio"),
    nomeFantasia: yup
        .string()
        .required("Campo obrigatorio"),
    tipo: yup
        .string()
        .required("Campo obrigatorio")
});

export const mapearData = (empresaBuyer) => {
    let data = {
        cnpj: empresaBuyer.cnpj,
        ie: empresaBuyer.ie,
        im: empresaBuyer.im,
        razaoSocial: empresaBuyer.razaoSocial,
        nomeFantasia: empresaBuyer.nomeFantasia,
        endereco: {
          cep: empresaBuyer.cep,
          logradouro: empresaBuyer.logradouro,
          numero: empresaBuyer.numero,
          complemento: empresaBuyer.complemento,
          bairro: empresaBuyer.bairro,
          cidade: empresaBuyer.cidade,
          estado: empresaBuyer.estado,
          urlGoogleMaps: empresaBuyer.urlGoogleMaps
        },
        tipo: empresaBuyer.tipo,
        telefone: {
          ddd: empresaBuyer.telefone.substring(0, 2),
          numero: empresaBuyer.telefone.substring(2, empresaBuyer.telefone.length)
        },
        atendimentoCargaDescarga: {
            horarioAtendimento: empresaBuyer.horarioAtendimento,
            contato: empresaBuyer.contato,
            observacoes: empresaBuyer.observacoes
        }
    }

    return data;
}

export const mapearResponseApi = (data) => {
    let response = {
        idCd: data.id,
        cnpj: data.cnpj,
        ativo: data.ativo,
        codigo: data.codigo,
        ie: data.ie,
        im: data.im,
        razaoSocial: data.razaoSocial,
        nomeFantasia: data.nomeFantasia,
        cep: data.endereco.cep,
        logradouro: data.endereco.logradouro,
        numero: data.endereco.numero,
        complemento: data.endereco.complemento,
        bairro: data.endereco.bairro,
        cidade: data.endereco.cidade,
        estado: data.endereco.estado,
        urlGoogleMaps: data.endereco.urlGoogleMaps,
        tipo: data.tipo,
        telefone: data.telefone.ddd + data.telefone.numero,
        horarioAtendimento: data.horarioAtendimento,
        contato: data.contato,
        observacoes: data.observacao
    }

    return response;
}

export const formCdInitialState = {
    idCd: "",
    cnpj: "",
    codigo: "",
    ie: "",
    ativo: false,
    im: "",
    razaoSocial: "",
    nomeFantasia: "",
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    urlGoogleMaps: "",
    tipo: "selecione",
    telefone: "",
    horarioAtendimento: "",
    contato: "",
    observacoes: ""
};